import {CompanyProperty, Landlord} from 'types/property';
import styles from './PropertyInfo.module.scss';
import {get} from 'lodash';
import {Fragment} from 'react/jsx-runtime';
import Typography from 'components/Typography';
import {Image} from 'types/Image';
import {separateMediaFiles} from 'helpers/media';
import ImageView from 'components/ImageView';
import MediaView from 'components/MediaView';
import {useState} from 'react';

interface PropertyInfoProps {
  property: CompanyProperty;
  landlord?: Landlord;
  description?: string;
  propertyImages?: Image[];
}

const PropertyInfo: React.FC<PropertyInfoProps> = ({
  property,
  landlord,
  description,
  propertyImages,
}) => {
  const [showImages, setShowImages] = useState(false);
  const [showMedia, setShowMedia] = useState(false);
  return (
    <div className={styles.card}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>Property Details</h2>
      </div>
      <div className={styles.grid}>
        <div>
          {!!get(property, 'name', null) && (
            <Fragment>
              <Typography component="p" variant="label">
                Property
              </Typography>

              <Typography className={styles.text} component="p" variant="label">
                {get(property, 'name', null)}
              </Typography>
            </Fragment>
          )}
          {!!landlord && (
            <Fragment>
              <Typography component="p" variant="label">
                Landlord
              </Typography>

              <Typography className={styles.text} component="p" variant="label">
                {`${landlord?.first_name} ${landlord?.last_name}` ||
                  'No Landlord'}
              </Typography>
            </Fragment>
          )}
          {!!description && (
            <Fragment>
              <Typography component="p" variant="label">
                Issue Description
              </Typography>

              <Typography className={styles.text} component="p" variant="label">
                {description}
              </Typography>
            </Fragment>
          )}
        </div>
        <div>
          {propertyImages && !!propertyImages?.length && (
            <Fragment>
              {(() => {
                const {images, videos} = separateMediaFiles(
                  propertyImages || []
                );

                return (
                  <Fragment>
                    <Typography component="p" variant="label">
                      Attachments
                    </Typography>
                    {/* Images Section */}
                    {images.length > 0 && (
                      <Fragment>
                        <ImageView
                          show={showImages}
                          onClose={() => setShowImages(false)}
                          images={images.map((image) => image?.large)}
                        />
                        {images.map((image) => (
                          <img
                            key={image.id}
                            onClick={() => setShowImages(true)}
                            src={image?.thumbnail}
                            alt={image?.file}
                            className={styles.attachedImage}
                          />
                        ))}
                      </Fragment>
                    )}

                    {/* Videos Section */}
                    {videos.length > 0 && (
                      <Fragment>
                        <MediaView
                          show={showMedia}
                          onClose={() => setShowMedia(false)}
                          mediaItems={videos}
                        />
                        {videos.map((video) => (
                          <div
                            key={video.id}
                            onClick={() => setShowMedia(true)}
                            className={styles.attachedVideo}
                          >
                            <video
                              src={video?.thumbnail}
                              className={styles.videoThumbnail}
                              muted
                            />
                            <div className={styles.videoOverlay}>
                              <svg
                                width="48"
                                height="48"
                                viewBox="0 0 24 24"
                                fill="white"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M8 5v14l11-7z" />
                              </svg>
                            </div>
                          </div>
                        ))}
                      </Fragment>
                    )}
                  </Fragment>
                );
              })()}
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyInfo;
